var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelocateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8814 2.13815C13.7049 1.4728 14.6272 1.43241 15.6349 1.44653C16.1562 1.45384 16.4168 1.4575 16.6258 1.53858C16.9576 1.66722 17.2216 1.93125 17.3502 2.26296C17.4313 2.47202 17.4349 2.73264 17.4423 3.25386C17.4564 4.26158 17.416 5.18389 16.7506 6.00736C16.1904 6.70079 15.2274 7.06314 14.764 7.82855C14.4102 8.41291 14.575 9.01806 14.727 9.64082L15.8646 14.3033C16.0914 15.2325 15.9188 15.828 15.2691 16.4777C14.9234 16.8234 14.6359 16.8059 14.3555 16.3591L10.9223 10.8888L9.28265 12.1921C8.68816 12.6647 8.39092 12.901 8.23474 13.2335C7.86887 14.0123 8.10114 15.182 8.11296 16.0263C8.11954 16.493 7.71625 17.4128 7.14559 17.4438C6.79328 17.463 6.67352 17.0416 6.55972 16.7829L5.46419 14.2928C5.2022 13.6973 5.19147 13.6866 4.59595 13.4246L2.1058 12.3291C1.84716 12.2153 1.42579 12.0955 1.44497 11.7432C1.47603 11.1725 2.39577 10.7693 2.86243 10.7758C3.70684 10.7877 4.87653 11.0199 5.65531 10.6541C5.98782 10.4979 6.22411 10.2006 6.69668 9.60615L7.99998 7.96651L2.5297 4.53325C2.08296 4.25287 2.06542 3.96532 2.41105 3.61971C3.06078 2.96997 3.65635 2.79747 4.58547 3.02418L9.24798 4.16182C9.87074 4.31378 10.4759 4.47862 11.0602 4.12482C11.8257 3.66145 12.188 2.69845 12.8814 2.13815Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelocateIcon);
export default __webpack_public_path__ + "static/media/relocateIcon.ab413875aefd3574efafe2e40eee9f17.svg";
export { ForwardRef as ReactComponent };